module.exports = __webpack_public_path__ + "sgby/img/prev.c9226ee.png";